import { render } from "./FadeCarousel .vue?vue&type=template&id=391da5f7&scoped=true"
import script from "./FadeCarousel .vue?vue&type=script&lang=js"
export * from "./FadeCarousel .vue?vue&type=script&lang=js"

import "./FadeCarousel .vue?vue&type=style&index=0&id=391da5f7&scoped=true&lang=css"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391da5f7"]])

export default __exports__